import {Pipe, PipeTransform} from '@angular/core';
import {getRelevantAdvertisements, Lottery} from "../model/lottery";
import {User} from "../services/user.service";
import {getRelevantApartmentsForIncomeAndSize, RelevantApartmentsResult} from "lottery-shared";

export type RelevantApartmentsInput = {
  type: 'user',
  user: User
} | {
  type: 'specified'
  lowerHouseholdIncome: number,
  upperHouseholdIncome: number,
  householdSize: number,
  receivesRentalAssistance: boolean,
  eligibleForSenior?: boolean
} | {
  type: 'all'
}

@Pipe({
  name: 'relevantAdvertisements',
  standalone: true
})
export class ApartmentRelevantAdvertisementsPipe<T extends Lottery> implements PipeTransform {
  transform(apartment: T, input: RelevantApartmentsInput): RelevantApartmentsResult<T['unitTypes'][number]> {
    switch (input.type){
      case "user":
        return getRelevantAdvertisements(apartment, input.user);
      case "specified":
        return getRelevantApartmentsForIncomeAndSize<T['unitTypes'][number]>(
          apartment.unitTypes,
          {
            lowerHouseholdIncome: input.lowerHouseholdIncome,
            upperHouseholdIncome: input.upperHouseholdIncome,
            size: input.householdSize,
            receivesRentalAssistance: input.receivesRentalAssistance,
            eligibleForSenior: input.eligibleForSenior ?? true
          },
        );
      case "all":
          return {
            status: 'eligible',
            advertisements: apartment.unitTypes
          };
    }
  }
}
